import APIService from 'services/APIService'

const api = APIService()

const IncidentsAPI = {
  list: params => api.get('/incidents', { params }),
  stats: params => api.get('/incidents/stats', { params }),
  get: id => api.get(`/incidents/${id}`),
  suggest: payload => api.post('/incidents/suggest', payload),
  create: payload => api.post('/incidents', payload),
  update: (id, payload) => api.patch(`/incidents/${id}`, payload),
  close: (id, payload = {}) => api.post(`/incidents/${id}/close`, payload),
  presignAttachment: (bpId, payload) =>
    api.post(`/building-passport/${bpId}/incidents/attachments/presign`, payload),
  confirmAttachment: (incidentId, payload) =>
    api.post(`/incidents/${incidentId}/attachments/confirm`, payload),
  listComments: id => api.get(`/incidents/${id}/comments`),
  createComment: (id, body) => api.post(`/incidents/${id}/comments`, { body }),
  listActivities: id => api.get(`/incidents/${id}/activities`),
  listWitnessStatements: id => api.get(`/incidents/${id}/witness-statements`),
  addWitnessStatement: (id, payload) => api.post(`/incidents/${id}/witness-statements`, payload),
  addContractor: (id, payload) => api.post(`/incidents/${id}/contractors`, payload),
  removeContractor: (id, contractorId) => api.delete(`/incidents/${id}/contractors/${contractorId}`),
  saveReportDetails: (id, type, payload) => api.put(`/incidents/${id}/report/${type}`, payload),
  downloadReport: (id, type) => api.get(`/incidents/${id}/report/${type}/docx`, { responseType: 'blob' }),
  markBuildingHrb: id => api.post(`/incidents/${id}/mark-hrb`),
}

export default IncidentsAPI
